"use strict";
var lib_core = require("lib-core");
var ui_extensions = require("ui-extensions");

var EcadioModelSelectorTrayModel = function (rootStateMachine, dataLoader, packageIM) {
    var self = this;
    ui_extensions.TrayAssetSearchTabModel.call(this, rootStateMachine, dataLoader);

    self.packageIM = packageIM;

    self.packageIM.packageGeometry.onChange("geometryChange", function(){
        self.loadData(0);
    })
};

lib_core.inherit(EcadioModelSelectorTrayModel, ui_extensions.TrayAssetSearchTabModel);
lib_core.JsonParser.registerClass(EcadioModelSelectorTrayModel, "EcadioModelSelectorTrayModel");

module.exports = EcadioModelSelectorTrayModel;


EcadioModelSelectorTrayModel.prototype.loadData = function(start) {
    this.getSuggestedPackagesFromEcadIo();
};


EcadioModelSelectorTrayModel.prototype.updateResults = function(data) {
    var self = this;

    if(data) {
        var results = [];

        data.forEach(function(result) {
            var urls = result['files'];
            var stepFileUrl = '';
            var thumbnailUrl = '';

            urls.forEach(function(url) {
                if(!url) return; // continue

                var ext = url.split('.').pop();

                if(ext === 'step' || ext === 'stp') {
                    stepFileUrl = url;
                } else if(ext === 'png') {
                    thumbnailUrl = url;
                }
            });

            results.push({
                'description': result['description'],
                'url': stepFileUrl,
                'thumbnailUrl': thumbnailUrl
            });
        });

        self.data(results);

    } else {//TODO: HANDLE ERROR
        console.warn('No match found :(');
    }
};

EcadioModelSelectorTrayModel.prototype.getSuggestedPackagesFromEcadIo = function() {
    var self = this;
    if(!self.packageIM.packageGeometry()) return;

    var height = self.packageIM.packageGeometry().getSize().z;
    var width = self.packageIM.packageGeometry().getSize().x;
    var length = self.packageIM.packageGeometry().getSize().y;

    var url = this.dataLoader.dataManager.contentServerURL + '/actions/ecadioProxy/API/Library/SuggestPackages';

    var name = self.packageIM.data.metaData().name();

    var data = {
        "criteria": 44,
        "packageName": name,
        "nResults": 20,
        "tolerance": 0.01,// 0.01,
        "refDes": 'U', // may be description metadata can be used for eagle packages
        "partNumber": 1234,
        "length": length,
        "width": width,
        "height": height
    };

    this.dataLoader.dataManager.getSuggestedPackagesFromEcadIo(url, data)
    .then(function(data){

        self.updateResults(JSON.parse(data));
        //self.loadingModel.removeLoad("EcadIO");
        //successCallback(JSON.parse(data));
    })
    .catch(function(e) {
        //self.loadingModel.removeLoad("EcadIO");
        logError("Get Suggested Packages", e, logError.criticality.MINOR, "Error connecting to Ecad.io");
    });
};

 